var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11963 5.50684C3.96729 5.50684 3.84424 5.44824 3.69775 5.30762L2.47314 4.15039C2.45557 4.13281 2.43213 4.12695 2.40576 4.12695H1.57373C1.146 4.12695 0.914551 3.88672 0.914551 3.43555V2.3457C0.914551 1.8916 1.146 1.6543 1.57373 1.6543H2.40576C2.43213 1.6543 2.45557 1.64551 2.47314 1.63086L3.69775 0.479492C3.85889 0.327148 3.96436 0.265625 4.11377 0.265625C4.33643 0.265625 4.49463 0.441406 4.49463 0.658203V5.13184C4.49463 5.34863 4.33643 5.50684 4.11963 5.50684ZM5.5376 4.18555C5.39697 4.08887 5.37354 3.92188 5.48193 3.75488C5.64307 3.52051 5.73682 3.20996 5.73682 2.88477C5.73682 2.55664 5.646 2.24609 5.48193 2.01465C5.37061 1.85059 5.39697 1.68066 5.5376 1.58691C5.66064 1.50195 5.82471 1.53125 5.9126 1.65723C6.1499 1.97656 6.2876 2.42188 6.2876 2.88477C6.2876 3.34766 6.1499 3.7959 5.9126 4.10938C5.82471 4.23828 5.66064 4.26465 5.5376 4.18555Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound-on.82503cb5e83ca678a977851d57e7524f.svg";
export { ForwardRef as ReactComponent };